let subscribeManager = (function (window) {

	/*navigator.serviceWorker.addEventListener('message', function (event) {
		if (event.source != navigator.serviceWorker.controller) {
			return;
		}
	});*/

	return {

		registration: null,
		subscription: null,
		serviceWorkerPath: '/service-worker.js.php',
		registerTokenUrl: '/notification/register',
		unRegisterTokenUrl: '/notification/unregister',

		init: function () {
			//alert('navigator.serviceWorker ' +  (typeof navigator.serviceWorker === 'undefined' ? 'T' : 'F'));
			if (typeof navigator.serviceWorker === 'undefined') return false;

			//console.log('subscribeManager init');

			return new Promise((resolve, reject) => {

				//console.log('start Promise')

				/**
				 * Catch ready state
				 */
				navigator.serviceWorker.ready
					.then(() => {
						//console.log('ready')
						return resolve;
					})
					.catch((err) => {
						//console.log(err)
						navigator.serviceWorker.register(this.serviceWorkerPath)
							.then(() => {
								//console.log('service ready')
								return resolve(navigator.serviceWorker.ready);
							})
							.catch(reject)
					})

				/**
				 * Register sw
				 */
				navigator.serviceWorker.register(this.serviceWorkerPath)
					.then(() => {
						//console.log('service register ready')
						return resolve(navigator.serviceWorker.ready);
					})
					.catch(reject)

			}).then((serviceWorkerRegistration) => {
				//console.log('subscribeManager registered', serviceWorkerRegistration, this);
				this.registration = serviceWorkerRegistration;
				//console.log('subscribeManager registered registration', this.registration);
				return serviceWorkerRegistration.pushManager.getSubscription().then(pushSubscription => {
					this.subscription = pushSubscription;
					return this.isSubscribe()
				});
			}).catch((error) => {
				console.log(error);
				return error
			});

		},

		isSubscribe: function () {
			return this.subscription !== null;
		},

		subscribe: function () {

			//console.log('call subscribe', this.isSubscribe(), this.subscription)

			if (this.isSubscribe()) {
				return new Promise((resolve, reject) => {
					//console.log(this.subscription.toJSON());
					fetch(this.registerTokenUrl, {
						method: 'POST',
						credentials: 'include',
						body: "data_token=" + JSON.stringify(this.subscription.toJSON()),
						headers: {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"}
					}).then(function (response) {
						return response.json();
					}).then((function (jsonResponse) {
						//this.subscription = pushSubscription;
						//console.log('subscribe to dek-d complete.', jsonResponse);
						this.showWelcomeMessage();
						this.createSubscribeCookie();
						resolve(jsonResponse)
					}).bind(this)).catch((error) => {
						reject(error);
					});
				});
			}

			return new Promise((resolve, reject) => {

				//console.log('service worker subscribe::', this, this.registration)
				//console.log('zzzzzz', this.registration)
				this.registration.pushManager.subscribe({userVisibleOnly: true}).then((function (pushSubscription) {
					//console.log('aaaa', pushSubscription)
					//console.log('subscribe', pushSubscription.toJSON());

					return fetch(this.registerTokenUrl, {
						method: 'POST',
						credentials: 'include',
						body: "data_token=" + JSON.stringify(pushSubscription.toJSON()),
						headers: {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"}
					}).then(function (response) {
						return response.json();
					}).then((function (jsonResponse) {
						this.subscription = pushSubscription;
						//console.log('subscribe to dek-d complete.', jsonResponse);
						this.showWelcomeMessage();
						this.createSubscribeCookie();
						resolve(jsonResponse)
					}).bind(this));

				}).bind(this)).catch(function (error) {
					//console.log('subscribe error.', error);
					reject(error)
				})
			});
		},


		unsubscribe: function () {

			if (!this.isSubscribe()) return false;

			return new Promise((resolve, reject) => {

				this.subscription.unsubscribe().then((function (response) {
					//console.log('unsubscribe', response);

					fetch(this.unRegisterTokenUrl, {
						method: 'POST',
						credentials: 'include',
						body: "data_token=" + JSON.stringify(this.subscription.toJSON()),
						headers: {"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"}
					}).then(function (response) {
						return response.json();
					}).then((function (jsonResponse) {
						//console.log("un-register complete", jsonResponse);
						this.removeSubscribeCookie();
						resolve(jsonResponse)
					}).bind(this));

				}).bind(this)).catch(function (error) {
					//console.log('Error un-subscribing', error);
					reject(error)
				});

			});
		},

		createSubscribeCookie: function () {
			let now = new Date();
			let exp = Date.now() + 31536000000; // 365 day in sec
			now.setTime(exp);
			document.cookie = "issubscriber=1;expires=" + now.toGMTString() + ";path=/;domain=.dek-d.com";
		},

		removeSubscribeCookie: function () {
			document.cookie = "issubscriber=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=.dek-d.com"; //clear cookie
		},

		showWelcomeMessage: function () {
			this.registration.showNotification('ขอบคุณที่ติดตามเรา', {
				body: 'ต่อไปการแจ้งเตือนจะขึ้นตรงนี้นะ',
				icon: 'https://www0.dek-d.com/assets/notification/images/default-noti.png',
				tag: 'first'
			})
		}
	};

})(window);

export default subscribeManager

export function unSubscribe() {
	subscribeManager.unsubscribe();
}

export function subscribe() {
	subscribeManager.subscribe();
}


window.tsub = subscribe
window.tunsub = unSubscribe





/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/service-register.js
 **/